import { render, staticRenderFns } from "./RecommendedMatches.vue?vue&type=template&id=7fe58e87&scoped=true"
import script from "./RecommendedMatches.vue?vue&type=script&lang=js"
export * from "./RecommendedMatches.vue?vue&type=script&lang=js"
import style0 from "./RecommendedMatches.vue?vue&type=style&index=0&id=7fe58e87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe58e87",
  null
  
)

export default component.exports